module.exports = __webpack_public_path__ + "static/media/using-lambdas-aws-cognito-and-stripe-on-wix.236bd367.md";